<h2 mat-dialog-title>{{ getTitle() | translate }}</h2>
<ng-container *ngIf="!isLoading(); else loading">
  <ng-container *ngIf="data?.readOnly; else editing">
    <mat-dialog-content>
      <span class="content">{{ data?.knowledgeSource?.config?.customDataConfig?.text }}</span>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-stroked-button (click)="cancel()">{{ 'COMMON.CLOSE' | translate }}</button>
      <a
        mat-flat-button
        [routerLink]="buildManageKnowledgeUrl()"
        [queryParams]="buildEditQueryParams()"
        color="primary"
        target="_blank"
      >
        {{ 'COMMON.EDIT' | translate }}
        <mat-icon iconPositionEnd>open_in_new</mat-icon>
      </a>
    </mat-dialog-actions>
  </ng-container>
</ng-container>

<ng-template #loading>
  <glxy-loading-spinner></glxy-loading-spinner>
</ng-template>

<ng-template #editing>
  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="custom-knowledge">
        <glxy-form-field>
          <glxy-label>{{ 'EDIT_KNOWLEDGE.NAME' | translate }}</glxy-label>
          <input matInput formControlName="name" />
        </glxy-form-field>
        <glxy-form-field>
          <glxy-label>{{ 'EDIT_KNOWLEDGE.CONTENT' | translate }}</glxy-label>
          <glxy-label-hint class="content-hint">{{ 'EDIT_KNOWLEDGE.CONTENT_HINT' | translate }}</glxy-label-hint>
          <textarea matInput formControlName="content" class="custom-knowledge-content" [rows]="10"></textarea>
        </glxy-form-field>
      </div>
    </form>
    <div *ngIf="data?.knowledgeSource">
      <ai-knowledge-apps-for-knowledge-source
        [knowledgeSourceId]="data.knowledgeSource.id"
      ></ai-knowledge-apps-for-knowledge-source>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button mat-flat-button color="primary" (click)="save()">{{ 'COMMON.SAVE' | translate }}</button>
  </mat-dialog-actions>
</ng-template>
